import {Directive, ElementRef, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ctrl-click]',
  standalone: true
})

export class CtrlClickDirective implements OnInit, OnDestroy {
  private unsubscribe: any;

  constructor(private readonly renderer: Renderer2,
              private router: Router,
              private readonly element: ElementRef) {
  }

  ngOnInit() {
    this.unsubscribe = this.renderer.listen(this.element.nativeElement, 'click', event => {
      if (event.ctrlKey) {
        event.preventDefault();
        event.stopPropagation();
        // unselect accidentally selected text (browser default behaviour)
        document.getSelection()?.removeAllRanges();
        if (this.element?.nativeElement?.href) {
          const path = this.element.nativeElement.href;
          window.open(path, '_blank');
        }
      }
    });
  }

  ngOnDestroy() {
    if (!this.unsubscribe) {
      return;
    }
    this.unsubscribe();
  }
}
